var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11097",
    "data-name": "Group 11097",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.83,
    height: 15.116,
    viewBox: "0 0 23.83 15.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3154",
    "data-name": "Rectangle 3154",
    width: 23.83,
    height: 15.116,
    fill: "#00b7cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11096",
    "data-name": "Group 11096",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28993",
    "data-name": "Path 28993",
    d: "M9.875,14.727,23.83,2.324,21.779,0,8.85,11.442,2.2,4.715,0,6.911l7.752,7.752a1.552,1.552,0,0,0,2.123.064",
    transform: "translate(0 0)",
    fill: "#00b7cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.c6c927c9b0d1db512cbaebcc53c63d42.svg";
export { ForwardRef as ReactComponent };